import styled from "styled-components";

const ProductImage = styled.img`
    width: 85%;
    margin: 0 auto;
    transition: transform 0.2s ease 0s;

    &:hover {
        transform: scale(1.1) translateZ(0);
    }
`;
export default ProductImage;
